/**
 * Enterprise Training Videos Page
 * Responsive thumbnail grid; click opens a centered modal player.
 */

import { navigate } from '../router';
import { openLessonVideoModal, closeLessonVideoModal } from '../ui/lessonVideoModal';

const VIDEOS = [
  {
    title: 'ADDING A DATA CONTROLLER',
    url: 'https://switchersimvids.blob.core.windows.net/vidstorage/Data-Controller.mp4',
  },
  {
    title: 'EDITING A SCOREBOARD',
    url: 'https://switchersimvids.blob.core.windows.net/vidstorage/edit-scoreboard.mp4',
  },
  {
    title: 'SETTING UP A NEW PROJECT',
    url: 'https://switchersimvids.blob.core.windows.net/vidstorage/setup-project.mp4',
  },
  {
    title: 'MEDIA SEQUENCES',
    url: 'https://switchersimvids.blob.core.windows.net/vidstorage/Media-Sequence.mp4',
  },
];

export function renderVideos(container: HTMLElement): void {
  const cards = VIDEOS.map((v, i) => `
    <button class="video-card" data-idx="${i}" type="button">
      <div class="video-card-thumb">
        <video src="${v.url}#t=0.5" preload="metadata" muted playsinline></video>
        <span class="video-card-play" aria-hidden="true">&#9658;</span>
      </div>
      <div class="video-card-title">${v.title}</div>
    </button>
  `).join('');

  container.innerHTML = `
    <div class="enterprise-page">
      <h2>TRAINING VIDEOS</h2>
      <div class="video-grid">
        ${cards}
      </div>
      <button class="ent-btn" id="ent-back-sessions">BACK TO SESSIONS</button>
    </div>
  `;

  container.querySelectorAll<HTMLButtonElement>('.video-card').forEach(btn => {
    btn.addEventListener('click', () => {
      const idx = Number(btn.dataset.idx);
      const v = VIDEOS[idx];
      if (v) openLessonVideoModal(v.url, v.title);
    });
  });

  container.querySelector('#ent-back-sessions')!
    .addEventListener('click', () => {
      closeLessonVideoModal();
      navigate('/sessions');
    });
}
